export const widgetTypes = {
    EXACTLY_ONE: "exactly_one",
    EXACTLY_ONE_PARENT: "exactly_one_parent",
    ALLOW_ONE: "allow_one",
    ALLOW_MULTIPLE: "allow_multiple",
    ONE_OR_MORE: "one_or_more",
    SELECT_MAX: "select_max",
    MULTIPLE_OF_EACH: "multiple_of_each",
};
